module.exports = __webpack_public_path__ + "img/brand9.088c62b0.png";